
























import { Component, Mixins } from 'vue-property-decorator'
import { AppItemRecord } from '@/tcw/domain/types'
import BasePage from '@/tcw/components/BasePage'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import AppMenuList from '@/components/application/molecules/AppMenuList.vue'
import Logout from '@/components/login/Logout.vue'

@Component({
  components: { TcwLayoutBasicTemplate, AppMenuList, Logout }
})
export default class AppMenuListPage extends Mixins(BasePage) {
  private logoutDialogVisible = false

  private items: AppItemRecord[] = [
    {
      rowId: '1',
      rowLabel: 'TCard',
      appItems: [
        {
          id: 1,
          icon: 'fas fa-arrow-left',
          label: '戻る',
          action: this.back
        },
        {
          id: 2,
          icon: 'fas fa-calendar',
          link: '/kintai/list',
          label: '勤怠一覧'
        },
        {
          id: 3,
          icon: 'fas fa-stopwatch',
          link: '/timecard',
          label: 'タイムカード'
        }
      ]
    },
    {
      rowId: '2',
      rowLabel: '承認',
      appItems: [
        {
          id: 1,
          icon: 'fas fa-train',
          label: '交通費',
          action: this.gotoTodaysKoutsuhiInputPage
        },
        {
          id: 2,
          icon: 'fab fa-telegram-plane',
          link: '/teishutsu/last',
          label: '提出'
        },
        {
          id: 3,
          icon: 'fas fa-stamp',
          link: '/shounin/tasks',
          label: '承認依頼',
          badge: this.countShouninTask
        }
      ]
    },
    {
      rowId: '4',
      rowLabel: 'ヘルプ',
      appItems: [
        {
          id: 1,
          icon: 'fas fa-users',
          link: '/shounin/users',
          label: '未承認'
        },
        { id: 2, icon: 'fas fa-question', link: '/help', label: 'ヘルプ' },
        {
          id: 3,
          icon: 'fas fa-chalkboard-teacher',
          link: '/forum',
          label: 'フォーラム'
        }
      ]
    },
    {
      rowId: '3',
      rowLabel: 'その他機能',
      appItems: [
        {
          id: 1,
          icon: 'fas fa-envelope',
          link: '/toiawase',
          label: '問い合わせ'
        },{ id: 2, icon: 'fas fa-file-excel', link: '/excel', label: 'エクセル' },
        {
          id: 3,
          icon: 'fas fa-bed',
          link: '/vacation',
          label: '有休日数'
        }
      ]
    },
    {
      rowId: '5',
      rowLabel: 'その他',
      appItems: [{ id: 1, icon: 'fas fa-cog', link: '/settei/list', label: '個人設定' },
        {
          id: 3,
          icon: 'fas fa-sign-out-alt',
          label: 'ログアウト',
          action: this.openLogoutDialog
        }
      ]
    }
  ]

  protected openLogoutDialog(): void {
    this.logoutDialogVisible = true
  }
  private gotoTodaysKoutsuhiInputPage(): void {
    // ストアのcurrentDateに現在の日付を設定
    this.$tcw.$store.basic.setTargetDate(this.du.now())
    this.$router.push('/koutsuhi/input/')
  }
}
